import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  Column,
  Columns,
  Heading,
  IconSearch,
  Stack,
  TextField,
  useResponsiveValue,
} from 'braid-design-system';
import type { ComponentProps, FC, FormEventHandler } from 'react';

import translations from './.vocab';

interface HeadingAndSearchProps {
  searchTerm: {
    value: string;
    onChange: FormEventHandler<HTMLInputElement>;
    onBlur: FormEventHandler<HTMLInputElement>;
  };
}

export const HeadingAndSearch: FC<HeadingAndSearchProps> = ({ searchTerm }) => {
  const { t } = useTranslations(translations);
  const headingLevel = (useResponsiveValue()({
    mobile: '3',
    tablet: '2',
  }) ?? '2') as ComponentProps<typeof Heading>['level'];

  return (
    <Stack space="medium">
      <Heading level={headingLevel} component="h1">
        {t('Search all your applicants')}
      </Heading>

      <Box maxWidth="small">
        <Columns space="small">
          <Column>
            <TextField
              value={searchTerm.value}
              onChange={searchTerm.onChange}
              onBlur={searchTerm.onBlur}
              icon={<IconSearch />}
              id="search-text"
              aria-label={t('Search by name, job title, email, phone number')}
              placeholder={t('Search by name, job title, email, phone number')}
              autoFocus
              inputMode="search"
            />
          </Column>
          <Column width="content" hideBelow="tablet">
            <Button tone="brandAccent" type="submit">
              {t('Search')}
            </Button>
          </Column>
        </Columns>
      </Box>
    </Stack>
  );
};
